<div class="date-picker d-flex">
  <button class="btn shadow-sm calendar-arrow" (click)="moveLeft()" [disabled]="disabledLeft">
    <i class="far fa-chevron-left pointer"></i>
  </button>
  @if (pickedDay) {
    <span>
      <button class="btn btn-default calendar-icon" (click)="dp.show()">
        <i class="far fa-calendar" aria-hidden="true"></i>
      </button>
      <input
        placement="bottom right"
        class="form-control date-picker-input shadow-sm"
        #dp="bsDatepicker"
        [minMode]="minMode"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [bsConfig]="bsConfig | async"
        [bsValue]="pickedDay"
        (bsValueChange)="changeDay($event)"
        bsDatepicker />
    </span>
  }
  <button class="btn shadow-sm calendar-arrow" (click)="moveRight()"  [disabled]="disabledRight">
    <i class="far fa-chevron-right pointer"></i>
  </button>
</div>